/**
 * Insider Smart Recommender accessibility: line-clamp can leave description
 * controls without visible text or an accessible name. Sync from [role="status"]
 * and ensure aria-label on links/buttons. Do not modify title links.
 */
(function () {
  var MIN_DESCRIPTION_LENGTH = 40;

  var DESCRIPTION_LINK_SELECTOR =
    ".ins-sample-element-children.ins-dynamic-text-product-link";

  function truncateDescription(text) {
    var sentences = text.match(/[^.!?]+[.!?]+/g);
    if (!sentences || sentences.length <= 2) return text.trim();
    return (sentences[0] + " " + sentences[1]).trim();
  }

  function accessibleName(el) {
    if (!el) return "";
    return (
      (el.getAttribute("aria-label") || "").trim() ||
      (el.getAttribute("title") || "").trim() ||
      (el.textContent || "").replace(/\s+/g, " ").trim()
    );
  }

  function getBoxTitle(box) {
    if (!box) return "";
    var titleLink = box.querySelector(
      ".ins-product-box-link.ins-dynamic-text-product-link",
    );
    return titleLink ? titleLink.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function getDescriptionFromStatus(link) {
    var status = link.closest('[role="status"]');
    if (!status) return "";

    var description = (status.getAttribute("aria-label") || "").trim();
    if (description.length < MIN_DESCRIPTION_LENGTH) return "";

    var linkLabel = (link.getAttribute("aria-label") || "").trim();
    if (linkLabel && description === linkLabel) return "";

    return truncateDescription(description);
  }

  function buildAccessibleLabel(title, description) {
    if (title && description) return title + ". " + description;
    return description || title || "";
  }

  function fixDescriptionControl(link) {
    if (link.matches(".ins-product-box-link")) return;

    var box = link.closest(".ins-web-smart-recommender-box-item");
    var title = getBoxTitle(box);

    var description =
      getDescriptionFromStatus(link) ||
      (link.textContent || "").replace(/\s+/g, " ").trim();

    if (!link.textContent.trim() && description) {
      link.textContent = description;
    }

    var label = buildAccessibleLabel(title, description);
    if (!label) return;

    var isButton =
      link.matches("button") || link.getAttribute("role") === "button";
    if (isButton || !accessibleName(link)) {
      link.setAttribute("aria-label", label);
    }

    var status = link.closest('[role="status"]');
    if (status && title) {
      status.setAttribute(
        "aria-label",
        buildAccessibleLabel(title, description),
      );
    }
  }

  function fixUnlabeledButtons(box) {
    if (!box) return;
    box.querySelectorAll("button").forEach(function (button) {
      if (accessibleName(button)) return;
      var text = (button.textContent || "").replace(/\s+/g, " ").trim();
      if (text) {
        button.setAttribute("aria-label", text);
        return;
      }
      var title = getBoxTitle(box);
      if (title) button.setAttribute("aria-label", title);
    });
  }

  function fixInsiderDescriptions(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope
      .querySelectorAll(".ins-web-smart-recommender-box-item")
      .forEach(function (box) {
        box
          .querySelectorAll(DESCRIPTION_LINK_SELECTOR)
          .forEach(function (link) {
            if (link.matches("a, button, [role='button']")) {
              fixDescriptionControl(link);
            }
          });
        fixUnlabeledButtons(box);
      });
  }

  function isInsiderNode(node) {
    if (!node || node.nodeType !== 1 || !node.matches) return false;

    return (
      node.matches(
        ".ins-web-smart-recommender, .ins-web-smart-recommender-box-item, .ins-dynamic-text-product-link, .ins-sample-element-children",
      ) || !!node.querySelector(".ins-web-smart-recommender-box-item")
    );
  }

  function startObserver() {
    if (!window.MutationObserver) {
      fixInsiderDescriptions();
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (isInsiderNode(node)) fixInsiderDescriptions(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    fixInsiderDescriptions();
    startObserver();
    window.addEventListener("load", fixInsiderDescriptions);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
